/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Payment_PlansInputs */

const en_nav_payment_plans = /** @type {(inputs: Nav_Payment_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment Plans`)
};

const es_nav_payment_plans = /** @type {(inputs: Nav_Payment_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planes de pago`)
};

/**
* | output |
* | --- |
* | "Payment Plans" |
*
* @param {Nav_Payment_PlansInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_payment_plans = /** @type {((inputs?: Nav_Payment_PlansInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Payment_PlansInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_payment_plans(inputs)
	return es_nav_payment_plans(inputs)
});